import React, { Component } from 'react'
import { Row, Col } from 'react-flexbox-grid'
import TitledLabel from '../../../../controls/TitledLabel'
import Divider from '@material-ui/core/Divider'
import { HorizontalBar } from 'react-chartjs-2'
import { localize } from '../../../../util/Localizer'
import { Colors } from '../../../../theme'
import Columns from '../../../../styles/columns'
import RBButton from '../../../../controls/RBButton'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { push } from 'connected-react-router'

class SingleUnitMax extends Component {
  constructor () {
    super()
    this.showAssociatedClaim = this.showAssociatedClaim.bind(this)
    this.renderViewAssociatedClaimsButton = this.renderViewAssociatedClaimsButton.bind(this)
  }

  showAssociatedClaim (e) {
    e.stopPropagation()
    const accumClaimParams = this.props.data.accumClaimParameters
    window.localStorage.removeItem('claimsParams')
    window.localStorage.setItem('claimsParams', JSON.stringify(accumClaimParams))
    this.props.push('/AssociatedClaimLines')
  }

  renderViewAssociatedClaimsButton () {
    if (!this.props.data.accumClaimParameters) {
      return null
    } else {
      return <RBButton variant='outlined' onClick={this.showAssociatedClaim} className='claimButton hidden-xs hidden-sm visible-md visible-lg' label={localize('pages.benefitDetails.dollarMax.btn')} />
    }
  }

  render () {
    let unitData = this.props.data
    let balance = unitData.availableAmount
    const options = {
      legend: {
        display: false
      },
      scales: {
        yAxes: [{
          display: false,
          stacked: true,
          scaleLabel: {
            display: false
          },
          ticks: {
            stepSize: 1
          }
        }],
        xAxes: [{
          display: false,
          stacked: true,
          scaleLabel: {
            display: false
          },
          ticks: {
            stepSize: 1
          }
        }]
      },
      maintainAspectRatio: false
    }
    const data = {
      labels: [''],
      datasets: [
        {
          label: localize('pages.benefitDetails.unitMax.horizontalBar.label1'),
          backgroundColor: Colors.Chart.primaryColor,
          data: [balance]
        },
        {
          label: localize('pages.benefitDetails.unitMax.horizontalBar.label2'),
          backgroundColor: Colors.Chart.secondaryColor,
          data: [unitData.spentAmount]
        }
      ]
    }
    return (
      <div>
        <Row middle='xs'>
          <Col {...Columns.max3}>
            <TitledLabel title='pages.benefitDetails.unitMax.category' value={unitData.categoryDescription} format='text' />
          </Col>
          <Col {...Columns.max3}>
            <TitledLabel title='pages.benefitDetails.common.period' value={[unitData.startPeriodDate, unitData.endPeriodDate]} format='dateRange' />
          </Col>
          <Col {...Columns.max3}>
            <Row end='xs'>
              {this.renderViewAssociatedClaimsButton()}
            </Row>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <div className='horizontalContainer' alt={`${localize('pages.benefitDetails.unitMax.horiztontalBar.alt1')} ${unitData.categoryDescription}. ${localize('pages.benefitDetails.unitMax.horiztontalBar.alt2')} ${balance}. ${localize('pages.benefitDetails.unitMax.horiztontalBar.alt3')} ${unitData.spentAmount}.`}>
              <HorizontalBar data={data} options={options} height={76} />
            </div>
          </Col>
        </Row>
        <Row between='sm' className='graphLabels'>
          <Col {...Columns.max3}>
            <Row>
              <Col>
                <p>{localize('pages.benefitDetails.unitMax.horizontalBar.label1')}: {balance}</p>
              </Col>
            </Row>
          </Col>
          <Col {...Columns.max3}>
            <Row end='md'>
              <Col>
                <p>{localize('pages.benefitDetails.unitMax.horizontalBar.label2')}: {unitData.spentAmount}</p>
              </Col>
            </Row>
          </Col>
        </Row>
        <Divider />
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
  }
}
const ConnectedSingleUnitMax = connect(mapStateToProps, { push })(injectIntl(SingleUnitMax))

export default ConnectedSingleUnitMax



// WEBPACK FOOTER //
// ./src/widgets/Member/benefitsWidgets/commonDetails/SingleUnitMax.js